/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import PropTypes from 'prop-types';

// Component imports
import { Card, Col, Row } from 'antd';

const ExternalAnalytics = ({ url }) => {

  return (
    <Row type="flex" gutter={24}>
      <Col xs={24} className="mb-6">
        {/* The background color is specific to Kibana's background color */}
        <Card bordered className="p-0 overflow-hidden" style={{ background: '#f8f9fb' }}>
          <iframe
            title="external-analytics"
            src={url}
            className="w-100 border-0"
            height={2700}
            loading="lazy"
          />
        </Card>
      </Col>
    </Row>
  );

};

ExternalAnalytics.propTypes = {
  url: PropTypes.string
};

export default ExternalAnalytics;
